"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_LIMIT = exports.ACTION = exports.TYPE = void 0;
var TYPE = {
  ALERT: 'alert',
  NOTICE: 'notice',
  WARNING: 'warning',
  INFO: 'info'
};
exports.TYPE = TYPE;
var ACTION = {
  SHOW: 'SHOW_TOAST',
  MOUNTED: 'CONTAINER_MOUNTED',
  CLEAR: 'CLEAR_TOAST'
};
exports.ACTION = ACTION;
var MAX_LIMIT = 8;
exports.MAX_LIMIT = MAX_LIMIT;